import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import SelectionToolbar from '@opsbase/web-data-selection/SelectionToolbar';
import useSelection from '@opsbase/web-data-selection/useSelection';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback, useMemo } from 'react';
import useAssets from "@opsbase/react-gql-hooks/asset/useAssets";
export function AssetsSelectionToolbar() {
    const dataType = DataType.ASSET;
    const { goTo } = useNav();
    const { selecteds } = useSelection(dataType);
    const noOfSelecteds = (selecteds === null || selecteds === void 0 ? void 0 : selecteds.length) || 0;
    const { data: assets } = useAssets({
        variables: { id: selecteds.map(s => s.id) },
    });
    const canCompare = noOfSelecteds > 1 && noOfSelecteds < 4 && (assets === null || assets === void 0 ? void 0 : assets.some(a => !!a.sensor));
    const handleClickEdit = useCallback(() => {
        goTo(Pages.ASSETS_MULTI_EDIT, { id: 'selected' });
    }, [goTo]);
    const handleClickDelete = useCallback(() => {
        goTo(Pages.ASSETS_DELETE, { id: 'selected' });
    }, [goTo]);
    const handleClickCompare = useCallback(() => {
        goTo(Pages.ASSETS_COMPARE);
    }, [goTo]);
    const actions = useMemo(() => [
        {
            label: i18n.t('delete'),
            Icon: DeleteIcon,
            color: Palette.error,
            onClick: handleClickDelete,
        },
        {
            label: i18n.t('edit'),
            Icon: EditIcon,
            color: Palette.secondary,
            onClick: handleClickEdit,
        },
        {
            label: i18n.t('compare'),
            color: Palette.secondary,
            disabled: !canCompare,
            onClick: handleClickCompare,
        },
    ], [canCompare, handleClickCompare, handleClickDelete, handleClickEdit]);
    return React.createElement(SelectionToolbar, { dataType: dataType, actions: actions });
}
export default AssetsSelectionToolbar;
